/* eslint-disable jsdoc/check-param-names */
/* eslint-disable jsdoc/require-param */
/**
 * Checks if a module is relevant to the current user based on selected levels, product types, and suppliers.
 * @param {object} moduleAttributes - The attributes of the module to check.
 * @param {number} rank - The current user's rank.
 * @param {Array<string>} selectedProductTypes - The product types relevant to the user.
 * @param {Array<string>} selectedSuppliers - The suppliers relevant to the user.
 * @returns {boolean} - Whether the module is relevant to the user.
 */
export default function isModuleRelevant(
  product_types,
  suppliers,
  training_types,
  is_compulsory,
  refs_structure_level_id,
  selected_product_types,
  selected_suppliers,
  is_leader,
  user_refs_max_structure_level_id
) {
  // Check if the module's product type is relevant to the user.
  const isProductTypeRelevant =
    !product_types ||
    product_types.length === 0 ||
    selected_product_types.some(type => product_types.includes(type?.id));

  // Check if the module's suppliers are relevant to the user.
  const isSupplierRelevant =
    !suppliers ||
    suppliers.length === 0 ||
    selected_suppliers.some(supplier => suppliers.includes(supplier?.id));

  const isLeaderRelevant =
    !training_types ||
    training_types === 1 ||
    (is_leader && training_types > 0);

  const isCompulsory = is_compulsory;

  const leaderSubStatusesRelevant =
    (training_types === 2 &&
      refs_structure_level_id <= user_refs_max_structure_level_id &&
      is_leader) ||
    !is_leader ||
    (is_leader && training_types <= 1);

  const relevant =
    isProductTypeRelevant &&
    isSupplierRelevant &&
    isLeaderRelevant &&
    leaderSubStatusesRelevant;

  const compulsory = relevant && isCompulsory;

  return {
    relevant,
    compulsory,
  };
}
